@if (isReady) {
  <div class="question-container" *transloco="let t">
    <div class="title-box">
      <p (click)="showQuestionsPopUp()">{{selectedIndex+1}}<span>/</span><span>{{questionList.length}}</span></p>
      <app-header [progressIsVisible]="!readOnly" [progress]="progress"></app-header>
    </div>
    <div class="question-content">
      <div class="description">
        <p>
          {{selectedQuestion().description}}
        </p>
        @if (visibleBlock !== QuestionState.ReadOnlyView) {
          <app-svg-icon (click)="showInfirmation()" class="logo" [path]="'/assets/info-regular.svg'"></app-svg-icon>
        }
      </div>
      @if (visibleBlock === QuestionState.ReadOnlyView) {
        <div class="info">
          <table>
            @for (info of infoList; track info.name; let i = $index) {
              <tr>
                <td class="name">{{t(info.name)}}</td>
                <td class="full">
                  @for (value of info.values; track value) {
                    <span
                      [ngClass]="setClass(value)">
                  {{ t(value) }}
                </span>
                  }
                </td>
                @if (i === 0 && selectedQuestion().images.length > 0) {
                  <td>
                    <div class="image-counter">
                      <p class="subheadline-emphasized">{{selectedQuestion().images.length}}</p>
                      <app-svg-icon class="logo" [path]="'/assets/image_icon.svg'"></app-svg-icon>
                    </div>
                  </td>
                }
              </tr>
            }
            @if (visibleBlock === QuestionState.ReadOnlyView) {
              <tr>
                <td colspan="3">
                  <p class="sort">{{shortText(selectedQuestion().comment, 140)}}
                    @if (selectedQuestion().comment && selectedQuestion().comment.length > 140) {
                      <span (click)="showDescription()">{{ t('AUDIT-PAGE.ACTIONS.MORE') }}</span>
                    }
                  </p>
                </td>
              </tr>
            }
          </table>
        </div>
      }

      @if (visibleBlock === QuestionState.FirstBlock) {
        <div class="block options">
          <app-option-view [(options)]="questionList[selectedIndex].stateOptions"
                           [showErrorMessage]="showErrorMessage"></app-option-view>
        </div>
      } @else if (visibleBlock === QuestionState.SecondBlock) {
        <app-input-select [label]="t('AUDIT-PAGE.LABELS.WORKSTATION')" [hint]="t('AUDIT-PAGE.HINTS.WORKSTATION')"
                          [options]="workstationList"
                          [formGroup]="workstationFormGroup"></app-input-select>
        <div class="block options">
          <app-option-view [(options)]="questionList[selectedIndex].deviations"
                           [(selected)]="questionList[selectedIndex].deviation"
                           [showErrorMessage]="showErrorMessage"></app-option-view>
        </div>
      } @else if (visibleBlock === QuestionState.ThirdBlock || visibleBlock === QuestionState.ReadOnlyView) {
        <div class="block images">
          <app-image-view [(images)]="questionList[selectedIndex].images" [readonly]="readOnly"></app-image-view>
        </div>
        @if (visibleBlock !== QuestionState.ReadOnlyView) {
          <div class="block comment">
            <p class="subtitle">{{ t('COMMON.LABEL.COMMENT') }}</p>
            <textarea class="comment-box" [placeholder]="t('AUDIT-PAGE.HINTS.COMMENT-PLACEHOLDER')"
                      [(ngModel)]="questionList[selectedIndex].comment"></textarea>
          </div>
          <div class="button secondary" (click)="duplicateQuestion()" [class.disabled]="!nextIsAvailable()"
               [style.pointer-events]="!nextIsAvailable() ? 'none' : 'auto'">
            <p class="main-text">{{ t('AUDIT-PAGE.ACTIONS.DUPLICATE') }}</p>
          </div>
        }
      }
    </div>
    <div class="navigation">
      <app-navigation-box [rightText]="t(buttonText())" [rightIsActive]="nextIsAvailable()" [leftIsActive]="backIsActive()"
                          (leftIsPressed)="back()" (rightIsPressed)="next()"></app-navigation-box>
    </div>
  </div>
}

<app-popup [(isOpen)]="questionsVisible" [dynamicComponent]="dynamicComponent" [data]="popupData" [readonly]="readOnly"
           [from]="slideInFrom"></app-popup>
